module.exports = __webpack_public_path__ + "static/secondary-2fb0205ccf2216ad67167302f19c55d3.mp4";